import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import api from "../api/api";

export default function Auth() {
  const [step, setStep] = useState('mobile');
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [tempUser, setTempUser] = useState(null);
  const { setUser, setIsAuthenticated } = useApp();
  const navigate = useNavigate();
  const generateCaptcha = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let captcha = "";
    for (let i = 0; i < 5; i++) captcha += chars[Math.floor(Math.random() * chars.length)];
    return captcha;
  };
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState('');
  const [otpAttempts, setOtpAttempts] = useState(0);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(true);

  useEffect(() => {
    const sessionExpiredMessage = sessionStorage.getItem('sessionExpiredMessage');
    if (sessionExpiredMessage) {
      setError(sessionExpiredMessage);
      sessionStorage.removeItem('sessionExpiredMessage');
    }

    const forgotMobile = localStorage.getItem('forgotMobile');
    if (forgotMobile) {
      setMobile(forgotMobile);
      const user = JSON.parse(localStorage.getItem('tempUser'));
      if (user) {
        setTempUser(user);
      }
      setStep('otp');
      localStorage.setItem('nextPage', 'OTP');
      localStorage.removeItem('forgotMobile');
    }
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError('');

    if (step === 'mobile') {
      if (!/^\d{10}$/.test(mobile)) return setError('Enter a valid 10-digit mobile number.');

      try {
        const res = await api.CustomerLoginApi(mobile);
        console.log("API response:", res);  // <--- check this

        const status = res?.CustomerLoginApijs?.Table?.[0]?.status || res?.CustomerLoginApijs?.Table?.[0]?.Status;
        const userData = res?.CustomerLoginApijs?.Table?.[0];
        const companyData = res?.CustomerLoginApijs?.Table1?.[0];

        console.log("status:", status);
        console.log("userData:", userData);

        if (status === 'Success') {
          const normalizedUser = {
            Vid: userData.Vid,
            Vcode: userData.Vcode || '',
            Vname: userData.Vname?.trim() || '',
            mail: userData.Mail?.trim() || '',
            address: userData.Address1?.trim() || '',
            area: userData.city?.trim() || '',
            division: userData.Division?.trim() || '',
            pin: (userData.Pincode || '').trim(),
            ShortName: userData.ShortName?.trim() || '',
            UserType: 'Existing User',
            Upicode: userData.Upicode,
            IsCodAvail: userData.IsCodAvail ||0,
            PinAllowed: userData.PinAllowed,
            companyAddress: companyData?.ComAddress?.trim() || '',
            companyName: companyData?.ComName?.trim() || '',
            companyEmail: companyData?.Email?.trim() || '',
            companyState: companyData?.State?.trim() || ''
          };

          setTempUser(normalizedUser);
          if (userData.NextPage === "PASSWORD") {
            localStorage.setItem('tempUser', JSON.stringify(normalizedUser));
            localStorage.setItem('nextPage', 'PASSWORD');
            navigate('/password');
          } else {
            localStorage.setItem('tempUser', JSON.stringify(normalizedUser));
            localStorage.setItem('nextPage', 'OTP');
            navigate('/otpverify');
          }
        }
        else if (status === 'Not Verified User') {
          const normalizedUser = {
            Vid: userData.Vid,
            Vcode: userData.Vcode || '',
            Vname: userData.Vname?.trim() || '',
            mail: userData.Mail?.trim() || '',
            address: userData.Address1?.trim() || '',
            area: userData.city?.trim() || '',
            division: userData.Division?.trim() || '',
            pin: (userData.Pincode || '').trim(),
            ShortName: userData.ShortName?.trim() || '',
            UserType: 'New User',
            Upicode: userData.Upicode,
            IsCodAvail: userData.IsCodAvail ||0,
            PinAllowed: userData.PinAllowed,
            companyAddress: companyData?.ComAddress?.trim() || '',
            companyName: companyData?.ComName?.trim() || '',
            companyEmail: companyData?.Email?.trim() || '',
            companyState: companyData?.State?.trim() || ''
          };
          setTempUser(normalizedUser);
          localStorage.setItem('tempUser', JSON.stringify(normalizedUser));
          localStorage.setItem('nextPage', 'OTP');
          navigate('/otpverify');
        }
        else if (status === 'New User') {
          alert('User not found. Please register first.');
          navigate('/register');
        }
        else if (status === 'Verification pending') {
          setError('Verification pending. Please contact support.');
        }
        else if (userData && userData.Vid) {
          // Handle successful login with user data
          const normalizedUser = {
            Vid: userData.Vid,
            Vcode: userData.Vcode || '',
            Vname: userData.Vname?.trim() || '',
            mail: userData.Mail?.trim() || '',
            address: userData.Address1?.trim() || '',
            area: userData.city?.trim() || '',
            division: userData.Division?.trim() || '',
            pin: (userData.Pincode || '').trim(),
            ShortName: userData.ShortName?.trim() || '',
            UserType: 'Existing User',
            Upicode: userData.Upicode,
            IsCodAvail: userData.IsCodAvail ||0,
            PinAllowed: userData.PinAllowed,
            companyAddress: companyData?.ComAddress?.trim() || '',
            companyName: companyData?.ComName?.trim() || '',
            companyEmail: companyData?.Email?.trim() || '',
            companyState: companyData?.State?.trim() || ''
          };

          setTempUser(normalizedUser);
          setStep('otp');
        }
        else {
          setError('Your account is currently inactive.');
        }
      } catch (err) {
        console.error("API error:", err);
        setError('Server error. Try again later.');
      }
        } else if (step === 'otp') {
      if (showOtpInput) {
        try {
          const verifyRes = await api.VerifyOtp(
            tempUser.Vcode,
            tempUser.UserType,
            otp,
            tempUser.Vid
          );
          const isVerified = verifyRes?.VerifyOtpjs?.Table?.[0]?.Status === 1;

          if (isVerified) {
            localStorage.setItem('tempUser', JSON.stringify(tempUser));
            navigate('/newpassword');
          } else {
            const newAttempts = otpAttempts + 1;
            setOtpAttempts(newAttempts);
            if (newAttempts >= 2) {
              setShowCaptcha(true);
              setShowOtpInput(false);
              setCaptcha(generateCaptcha());
            }
            setError('Invalid OTP. Please try again.');
            setOtp('');
          }
        } catch (err) {
          console.error('OTP verification failed:', err);
          setError('Failed to verify OTP. Please try again.');
        }
      } else {
        if (captchaInput === captcha) {
          setShowOtpInput(true);
          setShowCaptcha(false);
          setError('');
        } else {
          setError('Invalid Captcha. Please try again.');
          setCaptchaInput('');
          setCaptcha(generateCaptcha());
        }
      }
    }
  };

  return (
    <div className="flex flex-col justify-center items-center p-4 min-h-[80vh]">
                    {/* <div className="justify-center mb-4"><h1><b>Under Maintenance</b></h1></div> */}
      <div className="w-full max-w-sm mb-3 text-right">
        <Link
          to="/help/4"
          className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-gray-700 bg-white border border-gray-200 rounded-md hover:border-red-200 hover:text-red-600 hover:bg-red-50 transition"
          aria-label="Support and Policies"
          title="Policies & Support"
        >
          <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className="w-3.5 h-3.5"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M7 3h7l5 5v13a1 1 0 0 1-1 1H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M14 3v6h6M9 13h6M9 17h6" />
          </svg>
          Policies & Support
        </Link>
      </div>
             
      <div className="w-full max-w-sm p-8 bg-white shadow-lg rounded-2xl animate-fade-in">     
        <div className="mb-6 text-center">       
          <div className="inline-block p-4 ">
            <img
              src="/assets/AnnamLogo.PNG"   // <-- Correct public folder path
              alt="Logo"
              className="w-auto h-16"        // Adjust size as needed
            />
          </div>
          <h1 className="text-3xl font-bold text-gray-800">{step === 'mobile' ? 'Welcome!' : 'Verify OTP'}</h1>
          <p className="mt-2 text-gray-600">{step === 'mobile' ? 'Enter your mobile to begin.' : 'Enter the OTP sent to your mobile.'}</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          {step === 'mobile' ? (
           <input
  value={mobile}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, ''); // allow digits only
    if (value.length <= 10) {
      setMobile(value);
    }
  }}
  id="auth_mobile"
  type="tel"
  inputMode="numeric"
  pattern="[0-9]{10}"
  maxLength={10}
  placeholder="10-digit Mobile Number"
  className="w-full p-3 text-lg tracking-widest text-center border rounded-lg"
  required
/>

          ) : (
            <>
              {showOtpInput && (
                <input
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter OTP"
                  className="w-full p-3 text-lg tracking-widest text-center border rounded-md"
                />
              )}

              {showCaptcha && (
                <div className="mt-4">
                  <div className="flex items-center justify-between p-3 bg-gray-100 border rounded-lg">
                    <span className="text-xl font-bold tracking-widest">{captcha}</span>
                    <button
                      type="button"
                      onClick={() => setCaptcha(generateCaptcha())}
                      className="flex items-center justify-center w-10 h-10 text-2xl font-bold text-white transition bg-blue-500 rounded-full shadow-md hover:bg-blue-600"
                    >
                      ↻
                    </button>
                  </div>

                  <input
                    value={captchaInput}
                    onChange={(e) => setCaptchaInput(e.target.value)}
                    placeholder="Enter Captcha"
                    className="w-full p-3 mt-2 text-center border rounded-md"
                  />
                </div>
              )}

              {showOtpInput && (
                <p className="mt-2 text-xs text-center text-gray-500">
                  Enter the OTP sent to your mobile.
                </p>
              )}
            </>

          )}
          {error && <p className="text-sm text-center text-red-500">{error}</p>}
          <button type="submit" className="w-full py-3 font-bold text-white transition bg-red-500 rounded-lg hover:bg-red-600">
            {step === 'mobile' ? 'Continue' : 'Verify & Login'}
          </button>
        </form>

        <p className="mt-4 text-sm text-center text-gray-700">
          Don't have an account? <Link to="/register" className="font-semibold text-red-600">Sign Up</Link>
        </p>
        
        <p className="mt-8 text-xs text-center text-gray-500">
          © {new Date().getFullYear()} HITHAM ASSOCIATES PRIVATE LIMITED. All rights reserved.
        </p>
      </div>

    </div>
  );
}
